// AlertPopup.js
import { Alert } from '@mui/material';
import useAlert from '../hooks/useAlert';

const AlertPopup = () => {
  const { text, type } = useAlert();
  const { hideAlert } = useAlert();

  // let alertTitle = "";

  // if(type === "error"){
  //   alertTitle = "Error";
  // };
  // if(type === "success"){
  //   alertTitle = "Success";
  // };
  // if(type === "warning"){
  //   alertTitle = "Warning";
  // };

  
  if (text && type) {
    return (
      <Alert
        onClose={hideAlert}
        variant="filled"
        severity={type}
        sx={{
          position: 'absolute',
          zIndex: 10,
        }}
      >
        {text}
      </Alert>
    );
  } else {
    return <></>;
  }
};

export default AlertPopup;